<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <h3>App Component</h3>
            <h4>Timothy's First Project</h4>
            <hr>
            <app-servers></app-servers>
            <!--<div app-servers></div>-->
            <!--<div class="app-servers"></div>-->
            <hr>
            <app-success-alert></app-success-alert>
            <app-warning-alert></app-warning-alert>
            <hr>
            <app-sec2-as2></app-sec2-as2>
            <hr>
            <app-sec2-as3></app-sec2-as3>
        </div>
    </div>
</div>

